import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function PortfolioGallery() {
  const projects = [{
    image: 'https://cdn.magicpatterns.com/uploads/2j4ZyMpjoA7tq2ZP13NkcY/689ad4037b7578717090a7b4.webp',
    label: 'Complete Home Lighting — Scottsdale'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/gDZTvh2ireSXn3vpiBk9ne/bistro-lights.png',
    label: 'Bistro Lights — Scottsdale'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/88n9H6duUfUREiU7nFn7S1/landscape-lights.webp',
    label: 'Landscape Lighting — Paradise Valley'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/5TsNbk43GdmEb9FFUM9EfW/architectural-lights.webp',
    label: 'Architectural Lights — Chandler'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/tyB4NMqYPWvCMwRLnVqoq1/hardscape-lights.webp',
    label: 'Hardscape Lighting — Gilbert'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/vC75qQasDSkqbiRMo6SZTo/backyard-lights.webp',
    label: 'Backyard Oasis — Mesa'
  }];
  return <section className="w-full bg-[var(--brand-black)] py-20 lg:py-28" data-id="element-136">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-137">
        <div className="text-center mb-16" data-id="element-138">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white uppercase tracking-wider mb-4" data-id="element-139">
            See the Transformation
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-140">
            Browse our recent outdoor lighting projects across the Phoenix area
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-12" data-id="element-141">
          {projects.map((project, index) => <div key={index} className="group relative overflow-hidden rounded-lg aspect-square sm:aspect-[4/3] bg-gray-900 cursor-pointer" data-id="element-142">
              <img src={project.image} alt={project.label} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-143" />
              <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center p-6 text-center" data-id="element-144">
                <span className="text-white text-lg md:text-xl font-medium transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-145">
                  {project.label}
                </span>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-146">
          <Button variant="outline" size="lg" className="border-[var(--brand-gold)] text-[var(--brand-gold)] hover:bg-[var(--brand-gold)] hover:text-white font-medium text-lg h-14 px-8" data-id="element-147">
            View All Projects <ArrowRight className="ml-2 w-5 h-5" data-id="element-148" />
          </Button>
        </div>
      </div>
    </section>;
}